<script setup lang="ts">
import { computed } from 'vue';
import { DateTime } from 'luxon';
import { usePayment } from '@/composables/firebase/payment';

const { subscription: activeSubscription, previousSubscription, outstandingPayment } = usePayment();

const subscription = computed(() => activeSubscription.value || previousSubscription.value);

const gracePeriodEnd = computed(() => (
  subscription.value?.suspendedAt
    ? DateTime.fromISO(subscription.value.suspendedAt).plus({ days: 7 }).toFormat('dd.MM.yyyy, HH:mm')
    : null
));

const outstandingAmount = computed(() => {
  if (outstandingPayment.value) {
    return `${parseFloat(outstandingPayment.value.amount.value).toFixed(2).replace('.', ',').replace(',00', '')} €`;
  }

  return null;
});
</script>

<template>
  <div v-if="subscription && subscription.status === 'suspended'">
    <p
      v-if="activeSubscription"
      v-html="$t('SuspendedSubscription.description.gracePeriod', { gracePeriodEnd, outstandingAmount })" />
    <p
      v-else
      v-html="$t('SuspendedSubscription.description.afterGracePeriod', { gracePeriodEnd, outstandingAmount })" />
  </div>
</template>
